module.exports = __webpack_public_path__ + "static/media/leagues.134caeb8.svg";